export default "__VITE_ASSET__DWS$nyMD__"